import * as flight from 'flight';
import * as analytics from './login-signup-analytics';

export function trackLoginSuccess(memberId) {
    analytics.trackEvent('user-login-success', memberId);
}

export function trackLoginFailure(validationError) {
    analytics.trackEvent('user-login-fail', null, validationError);
}

function NavigateToSignupLink() {
    this._click = function() {
        analytics.method.set(analytics.METHOD.UNKNOWN);
        analytics.flow.set(analytics.FLOW.SIGNUP);
        analytics.trackEvent('user-signup-step-1');
    };
    this.after('initialize', function() {
        this.on('click', this._click.bind(this));
        analytics.flow.setIfEmpty(analytics.FLOW.LOGIN);
    });
}

function LoginWithFacebookButton() {
    this._click = function() {
        analytics.flow.set(analytics.FLOW.LOGIN);
        analytics.method.set(analytics.METHOD.FACEBOOK);
        analytics.trackEvent('user-login-submit');
    };
    this.after('initialize', function() {
        this.on('click', this._click.bind(this));
    });
}

function LoginWithPasswordButton() {
    this._click = function() {
        const connect = this.$node.data('loginConnect') || 'none';
        if (connect !== 'none') {
            analytics.trackEvent('user-connect-submit');
        } else {
            analytics.flow.set(analytics.FLOW.LOGIN);
            analytics.method.set(analytics.METHOD.PASSWORD);
            analytics.trackEvent('user-login-submit');
        }
    };
    this.after('initialize', function() {
        this.on('click', this._click.bind(this));
    });
}

function TrackLoginSuccess() {
    this.after('initialize', function() {
        analytics.trackEvent('user-login-success', this.$node.data('memberId'));
    });
}

function TrackConnectSuccess() {
    this.after('initialize', function() {
        analytics.trackEvent(
            'user-connect-success',
            this.$node.data('memberId')
        );
    });
}

function TrackLoginFailure() {
    this.after('initialize', function() {
        analytics.trackEvent(
            'user-login-fail',
            null,
            this.$node.data('errorCode')
        );
    });
}

function TrackConnectFailure() {
    this.after('initialize', function() {
        analytics.trackEvent(
            'user-connect-fail',
            null,
            this.$node.data('errorCode')
        );
    });
}

export const NavigateToSignupLinkComponent = flight.component(
    NavigateToSignupLink
);
export const LoginWithFacebookButtonComponent = flight.component(
    LoginWithFacebookButton
);
export const LoginWithPasswordButtonComponent = flight.component(
    LoginWithPasswordButton
);
export const TrackLoginSuccessComponent = flight.component(TrackLoginSuccess);
export const TrackConnectSuccessComponent = flight.component(
    TrackConnectSuccess
);
export const TrackLoginFailureComponent = flight.component(TrackLoginFailure);
export const TrackConnectFailureComponent = flight.component(
    TrackConnectFailure
);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/login-signup-events.js